import React from "react";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import grey from "@material-ui/core/colors/grey";
export const starRenderer = (value, handler, editable) => {
    const stars = [
        editable ? (
            <IconButton
                key={"clear"}
                onClick={() => handler("")}
                label="Нет звезд"
            >
                <HighlightOffIcon style={{ color: grey[300] }} />
            </IconButton>
        ) : null,
    ];
    if (value && value > 0) {
        for (let i = 0; i < value; i++) {
            stars.push(
                <IconButton
                    disabled={editable ? false : true}
                    style={{ padding: "6px" }}
                    key={"stars" + i}
                    onClick={() => handler(i + 1)}
                >
                    <StarRoundedIcon color={"primary"} />
                </IconButton>,
            );
        }
    }

    if (editable) {
        for (let i = stars?.length; i < 6; i++) {
            stars.push(
                <IconButton
                    style={{ padding: "6px" }}
                    key={"empty" + i}
                    onClick={() => handler(i)}
                >
                    <StarBorderRoundedIcon style={{ color: grey[300] }} />
                </IconButton>,
            );
        }
    }

    return stars;
};
